// ============================================
// PENDANT BUILDER - CARAT-BASED PRICING
// Modified: Text display with font and color classes
// ============================================

// Base Price
const basePrice = 0;

// Individual character pricing - Load from Shopify metafield
let letterData = {};
let isDataLoaded = false;

// Store all 3 carat metafield data
let allMetafieldCombos = {};

// Initialize all carat metafields from Shopify
(function initLetterData() {
    try {
        // Load all 3 carat-based metafields
        allMetafieldCombos = {
            '10k': window.pendantLetterData_10k_carat || null,
            '14k': window.pendantLetterData_14k_carat || null,
            '18k': window.pendantLetterData_18k_carat || null
        };
        
        // Check if at least one carat metafield loaded
        const loadedCombos = Object.keys(allMetafieldCombos).filter(key => 
            allMetafieldCombos[key] && typeof allMetafieldCombos[key] === 'object' && Object.keys(allMetafieldCombos[key]).length > 0
        );
        
        if (loadedCombos.length > 0) {
            isDataLoaded = true;
            console.log('✅ Carat letter data loaded. Available carats:', loadedCombos);
            
            // Set default to first available carat
            letterData = allMetafieldCombos[loadedCombos[0]];
        } else {
            console.error('❌ No metafield carat data found!');
            showError('Unable to load pendant pricing data. Please refresh the page.');
        }
    } catch (error) {
        console.error('❌ Error loading letter data:', error);
        showError('Error loading pendant builder. Please contact support.');
    }
})();

// Load dynamic pricing from section settings
// NOTE: Carat pricing is loaded from metafields,
// we only load Chain Length here from section settings
const chainLength = window.pendantPricingData?.chainLength || {
    "14inch": 100,
    "16inch": 120,
    "18inch": 130,
    "20inch": 150
};

console.log('💎 Pricing Data Loaded:');
console.log('- Chain Length:', chainLength);

// DOM Elements
const nameInput = document.getElementById("nameInput");
const heightEl = document.getElementById("heightValue");
const widthEl = document.getElementById("widthValue");
const priceValue = document.getElementById("priceValue");
const leftChain = document.querySelector(".leftChain img");
const rightChain = document.querySelector(".rightChain img");

// ============================================
// UTILITY FUNCTIONS
// ============================================

/**
 * Show error message to user
 */
function showError(message) {
    // Create error notification
    const errorDiv = document.createElement('div');
    errorDiv.className = 'pendant-error-notification';
    errorDiv.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #f44336;
        color: white;
        padding: 15px 20px;
        border-radius: 4px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        z-index: 9999;
        max-width: 300px;
    `;
    errorDiv.textContent = message;
    
    document.body.appendChild(errorDiv);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
        errorDiv.remove();
    }, 5000);
}

/**
 * Build the key from the currently selected carat radio.
 * Example: carat = "10k" → "10k"
 */
function getComboKey() {
    const caratEl = document.querySelector('input[name="carat"]:checked');
    const carat = caratEl ? caratEl.value.toLowerCase().trim() : '10k';
    return carat;
}

/**
 * Swap the active letterData to match the current carat key.
 * Returns true if the carat exists, false otherwise.
 */
function switchLetterData() {
    const key = getComboKey();
    
    if (allMetafieldCombos[key] && typeof allMetafieldCombos[key] === 'object') {
        letterData = allMetafieldCombos[key];
        console.log('🔄 Active carat switched to:', key);
        return true;
    }
    
    console.error('❌ Carat key not found in metafields:', key);
    showError(`Pricing not available for ${key}. Please select another carat.`);
    
    // Fallback to any available carat
    const availableCarat = Object.keys(allMetafieldCombos).find(k => 
        allMetafieldCombos[k] && typeof allMetafieldCombos[k] === 'object'
    );
    
    if (availableCarat) {
        letterData = allMetafieldCombos[availableCarat];
        console.warn('⚠️ Falling back to carat:', availableCarat);
        return true;
    }
    
    letterData = {};
    return false;
}

/**
 * Validate if character is supported
 */
function isCharacterSupported(char) {
    return letterData.hasOwnProperty(char);
}

/**
 * Validate entire input string
 */
function validateInput(text) {
    const errors = [];
    const unsupportedChars = [];
    
    if (!text || text.trim().length === 0) {
        errors.push('Please enter text for your pendant');
        return { valid: false, errors, unsupportedChars };
    }
    
    if (!isDataLoaded || Object.keys(letterData).length === 0) {
        errors.push('Pricing data not loaded. Please refresh the page.');
        return { valid: false, errors, unsupportedChars };
    }
    
    // Check each character
    for (let char of text) {
        if (!isCharacterSupported(char)) {
            unsupportedChars.push(char);
        }
    }
    
    if (unsupportedChars.length > 0) {
        errors.push(`Unsupported characters: ${unsupportedChars.join(', ')}`);
    }
    
    return {
        valid: errors.length === 0,
        errors,
        unsupportedChars
    };
}

/**
 * Get currently selected options with safe fallbacks
 */
function getSelectedOptions() {
    const colorInput = document.querySelector('input[name="color"]:checked');
    const fontInput = document.querySelector('input[name="font"]:checked');
    const caratInput = document.querySelector('input[name="carat"]:checked');
    const diamondInput = document.querySelector('input[name="diamond"]:checked');
    const lengthInput = document.querySelector('select[name="chain_length"]');
    
    return {
        color: colorInput ? colorInput.value : 'silver',
        font: fontInput ? fontInput.value : 'font1',
        carat: caratInput ? caratInput.value : '',
        diamond: diamondInput ? diamondInput.value : '',
        length: lengthInput ? lengthInput.value : '',
        colorTitle: colorInput ? colorInput.title : 'White Gold',
        caratKey: caratInput ? caratInput.value.toLowerCase().trim() : '',
        diamondKey: diamondInput ? diamondInput.value.toLowerCase().replace(/\s+/g, "-") : '',
        fontKey: fontInput ? fontInput.value.toLowerCase().trim() : '',
        lengthKey: lengthInput ? lengthInput.value.toLowerCase().trim() : ''
    };
}

/**
 * Calculate price breakdown
 * NOTE: Letter prices now come from the active carat metafield.
 * We only add Chain Length on top.
 */
function calculatePriceBreakdown(text, options) {
    let lettersPriceTotal = 0;
    const letterPrices = [];
    
    for (let char of text) {
        if (letterData[char]) {
            lettersPriceTotal += letterData[char].price;
            letterPrices.push({ char, price: letterData[char].price });
        }
    }
    
    const lengthPrice = options.lengthKey && chainLength[options.lengthKey] 
        ? chainLength[options.lengthKey] 
        : 0;
    
    const totalPrice = basePrice + lettersPriceTotal + lengthPrice;
    
    return {
        base: basePrice,
        letters: lettersPriceTotal,
        letterPrices,
        length: lengthPrice,
        total: totalPrice
    };
}

// ============================================
// CHAIN GAP MANAGEMENT
// ============================================

/**
 * Update chain gaps based on first and last characters
 * Simplified logic for better readability
 */
function updateChainGaps(text) {
    const leftDiv = document.querySelector('.leftChain');
    const rightDiv = document.querySelector('.rightChain');

    // Reset classes
    leftDiv.classList.remove('gap-a');
    rightDiv.classList.remove('gap-a');

    if (!text || text.length === 0) return;

    const firstChar = text[0];
    const lastChar = text[text.length - 1];

    const firstData = letterData[firstChar];
    const lastData = letterData[lastChar];

    if (!firstData || !lastData) return;

    // Left chain gap (based on first letter)
    if (firstData.chaingaptype === 1 || firstData.chaingaptype === 3) {
        leftDiv.classList.add('gap-a');
    }

    // Right chain gap (based on last letter)
    if (lastData.chaingaptype === 1 || lastData.chaingaptype === 4) {
        rightDiv.classList.add('gap-a');
    }
}

// ============================================
// MAIN UPDATE FUNCTION
// ============================================

/**
 * Update pendant preview and pricing
 */
function updatePendant() {
    if (!isDataLoaded) {
        console.error('❌ Cannot update: Letter data not loaded');
        return;
    }
    
    // 1. Switch to the correct carat metafield based on carat selection
    switchLetterData();
    
    const text = nameInput.value;
    const options = getSelectedOptions();
    
    // Validate input
    const validation = validateInput(text);
    if (!validation.valid && text.length > 0) {
        console.warn('⚠️ Validation errors:', validation.errors);
        // Note: Still allow preview but with warning
    }
    
    // Update text display in #goldletters
    const goldLettersDiv = document.getElementById('goldletters');
    if (goldLettersDiv) {
        goldLettersDiv.textContent = text || 'yourname';
        
        // Remove all gold color classes
        goldLettersDiv.classList.remove('white-gold', 'yellow-gold', 'rose-gold');
        
        // Add appropriate class based on color selection
        if (options.color === 'silver') {
            goldLettersDiv.classList.add('white-gold');
        } else if (options.color === 'gold') {
            goldLettersDiv.classList.add('yellow-gold');
        } else if (options.color === 'rosegold') {
            goldLettersDiv.classList.add('rose-gold');
        }
        //----**********----***------- Add New Font ------------***********-------
        // Remove all font classes
        goldLettersDiv.classList.remove('font1', 'font2', 'font3', 'font4', 'font5', 'font6',  'font7', 'font8', 'font9', 'font10');
        
        // Add appropriate class based on font selection
        if (options.font === 'font1') {
            goldLettersDiv.classList.add('font1');
        } else if (options.font === 'font2') {
            goldLettersDiv.classList.add('font2');
        }
        else if (options.font === 'font3') {
            goldLettersDiv.classList.add('font3');
        }
        else if (options.font === 'font4') {
            goldLettersDiv.classList.add('font4');
        }
         else if (options.font === 'font5') {
            goldLettersDiv.classList.add('font5');
        }
         else if (options.font === 'font6') {
            goldLettersDiv.classList.add('font6');
        }
         else if (options.font === 'font7') {
            goldLettersDiv.classList.add('font7');
        }
         else if (options.font === 'font8') {
            goldLettersDiv.classList.add('font8');
        }
         else if (options.font === 'font9') {
            goldLettersDiv.classList.add('font9');
        }
         else if (options.font === 'font10') {
            goldLettersDiv.classList.add('font10');
        }
    }

    let totalWidth = 0;
    let height = 0;

    // Calculate dimensions based on letter data
    for (let char of text) {
        if (letterData[char]) {
            totalWidth += letterData[char].width;
            height = letterData[char].height;
        }
    }

    // Update chain images
    const leftChainImage = `https://cdn.shopify.com/s/files/1/0606/0382/6250/files/${options.color}-left-chain.png`;
    const rightChainImage = `https://cdn.shopify.com/s/files/1/0606/0382/6250/files/${options.color}-right-chain.png`;

    

    updateChainGaps(text);

    leftChain.setAttribute("src", leftChainImage);
    rightChain.setAttribute("src", rightChainImage);

    // Calculate price breakdown
    const priceBreakdown = calculatePriceBreakdown(text, options);
    
    // Log price breakdown for debugging
    console.log('💰 Price Breakdown:', {
        carat: getComboKey(),
        text: text,
        base: `$${priceBreakdown.base}`,
        letters: `$${priceBreakdown.letters} (includes carat pricing)`,
        length: `$${priceBreakdown.length} (${options.length})`,
        total: `$${priceBreakdown.total}`
    });

    // Update UI
    priceValue.innerText = priceBreakdown.total;
    heightEl.innerText = `${height.toFixed(2)} INCH`;
    widthEl.innerText = "WIDTH MAY VARY";
    
    // Update title
    // const goldText = document.getElementById('goldSelection');
    // if (goldText) {
    //     goldText.textContent = options.colorTitle;
    // }
}

// ============================================
// EVENT LISTENERS
// ============================================

// Input field listener
nameInput.addEventListener("input", () => {
    const warning = document.getElementById("gold-name-warning");
    const length = nameInput.value.trim().length;

    if (length > 0 && length < 5) {
        warning.style.display = "inline";
        nameInput.classList.add("error");
    } else {
        warning.style.display = "none";
        nameInput.classList.remove("error");
    }

    if (nameInput.value.length > 10) return;

    if (length > 0) {
        leftChain.style.display = "block";
        rightChain.style.display = "block";
        updatePendant();
    } else {
        leftChain.style.display = "none";
        rightChain.style.display = "none";
    }
});

// Radio selections - dynamically find all available inputs
    document.addEventListener("DOMContentLoaded", function() {
    // Add event listeners only to existing radio buttons
    const radioSelectors = ['color', 'font', 'carat', 'diamond'];
    radioSelectors.forEach(name => {
        const radios = document.querySelectorAll(`input[name="${name}"]`);
        if (radios.length > 0) {
            radios.forEach(radio => {
                radio.addEventListener("change", updatePendant);
            });
            console.log(`✅ Event listeners added to ${radios.length} "${name}" inputs`);
        }
    });
    
    // Add event listener for chain length dropdown
   // Add event listener for chain length dropdown
    const lengthDropdown = document.querySelector('select[name="chain_length"]');
    if (lengthDropdown) {
        lengthDropdown.addEventListener('change', function() {
            this.classList.remove('error'); // Remove error class on change
            updatePendant();
        });
        console.log('✅ Event listener added to chain length dropdown');
    }
    
    // Initial update
    if (isDataLoaded) {
        updatePendant();
    } else {
        console.error('❌ Cannot initialize: Letter data not loaded');
    }
});

// ============================================
// UI INTERACTIONS
// ============================================

document.addEventListener('DOMContentLoaded', function () {
    // Changing product title based on color selection
    // const goldText = document.getElementById('goldSelection');
    // document.querySelectorAll('.radioWrap input[name="color"]').forEach(function (radio) {
    //     radio.addEventListener('change', function () {
    //         goldText.textContent = this.title;
    //     });
    // });

    // Thumbnail gallery
    const thumbs = document.querySelectorAll('.thumb-img');
    const preview = document.getElementById('previewImage');

    thumbs.forEach(function (img) {
        img.addEventListener('click', function () {
            preview.src = this.getAttribute('data-full');
            document.querySelectorAll('.thumb-img').forEach((i) => i.classList.remove('active'));
            this.classList.add('active');
        });
    });

    // ==========================================
    // PREVIEW BUTTON LOGIC
    // ==========================================
    
    const previewBtn = document.getElementById('previewToggleBtn');
    const gallery = document.querySelector('.custom-gallery-wrap');
    const previewBox = document.querySelector('.preview-box');

    const eyeOpenSVG = `
        <svg class="icon eye-open-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
            <circle cx="12" cy="12" r="3"/>
        </svg>
    `;

    const eyeCloseSVG = `
        <svg class="icon eye-close-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17.94 17.94C16.23 19.24 14.21 20 12 20c-7 0-11-8-11-8 1.16-2.03 2.64-3.78 4.38-5.09"/>
            <path d="M9.53 9.53a3 3 0 0 0 4.24 4.24"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
            <path d="M6.06 6.06C7.77 4.76 9.79 4 12 4c7 0 11 8 11 8 -1.16 2.03-2.64 3.78-4.38 5.09"/>
        </svg>
    `;

    let showPreview = false;

    function updatePreviewButton() {
        if (nameInput.value.trim() === '') {
            previewBtn.classList.add('disable');
            previewBtn.disabled = true;
            previewBtn.innerHTML = `Preview <span id="previewIcon">${eyeOpenSVG}</span>`;
            previewBox.style.display = 'none';
            gallery.style.display = 'block';
            showPreview = false;
        } else {
            previewBtn.classList.remove('disable');
            previewBtn.disabled = false;
        }
    }

    updatePreviewButton();
    nameInput.addEventListener('input', updatePreviewButton);

    previewBtn.addEventListener('click', () => {
        if (previewBtn.disabled) return;

        showPreview = !showPreview;

        if (showPreview) {
            previewBtn.innerHTML = `Preview <span id="previewIcon">${eyeCloseSVG}</span>`;
            gallery.style.display = 'none';
            previewBox.style.display = 'block';
        } else {
            previewBtn.innerHTML = `Preview <span id="previewIcon">${eyeOpenSVG}</span>`;
            gallery.style.display = 'block';
            previewBox.style.display = 'none';
        }
    });

    // ==========================================
    // QUANTITY CONTROLS
    // ==========================================
    
    const minusBtn = document.querySelector(".qty-minus");
    const plusBtn = document.querySelector(".qty-plus");
    const qtyInput = document.querySelector(".qty-input");

    if (minusBtn && plusBtn && qtyInput) {
        minusBtn.addEventListener("click", () => {
            let value = parseInt(qtyInput.value, 10);
            if (value > 1) qtyInput.value = value - 1;
        });

        plusBtn.addEventListener("click", () => {
            let value = parseInt(qtyInput.value, 10);
            qtyInput.value = value + 1;
        });
    }

    // ==========================================
    // ADD TO CART
    // ==========================================

    document.querySelectorAll('.field-preview-flex input#nameInput').forEach(input => {
        input.addEventListener('keyup', function(){
            input.classList.remove('error');
        });
    });

   document.querySelectorAll('.buy_buttons-wrapper button.pb_atc_btn').forEach(btn => {
    btn.addEventListener('click', async function(){
        const enterNameSel = document.querySelector('.field-preview-flex input#nameInput');
        
        // Validate input
        if (enterNameSel) {
            const value = enterNameSel.value.trim();

            if (value.length < 5) {
                enterNameSel.classList.add('error');
                enterNameSel.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });

                showError('Please enter at least 5 characters.');
                return;
            }
        }
        
        // Validate chain length selection
        const lengthDropdown = document.querySelector('select[name="chain_length"]');
        if(lengthDropdown && (lengthDropdown.value == "" || lengthDropdown.value == null)){
            lengthDropdown.classList.add('error');
            lengthDropdown.scrollIntoView({behavior: 'smooth', block: 'center' });
            showError('Please select a chain length');
            return;
        }
            
            // Validate characters
            const validation = validateInput(enterNameSel.value);
            if (!validation.valid) {
                showError(validation.errors[0]);
                enterNameSel.classList.add('error');
                return;
            }
            
            btn.classList.add('loading'); 
            btn.disabled = true;
            
            // const endpoint = 'https://new.magento-development.asia/highline-custom-jewelry/api/builder/custom-pendent';
             const endpoint = 'https://app.highlinecustomjewelry.com/highline-custom-jewelry/api/builder/custom-pendent';
            
            try {
                // Switch to preview if not already showing
                const hasPreviewView = document.querySelector('.pendant_builder_main .preview-box').style.display;
                if(hasPreviewView == 'none'){
                    previewBtn.click();
                }
                
                const title = document.querySelector('.gold_product_title').innerText;
                const price = document.querySelector('#priceValue').innerText;
                const image_url = await fastScreenshot();
                const productData = {
                    "title": title, 
                    "product_type": "", 
                    "tags": ["hidden", "Gold-Necklace"],
                    "price": price, 
                    "image_url": image_url
                };
                
                console.log('📤 Creating custom product:', productData);
                
                const response = await fetch(endpoint, {
                    method: "POST", 
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(productData)
                });
                
                if (!response.ok) {
                    throw new Error(`API Error: ${response.status} ${response.statusText}`);
                }
                
                const responseJson = await response.json();
                const variantID = responseJson.variant_id.split('/').pop();
                
                const quantity = document.querySelector('input.qty-input').value;
                const properties = {};
                properties['Enter name'] = enterNameSel.value;
                
                // Get all option values including chain length
                document.querySelectorAll('.pendant_builder_main .box .radioMain.option_wrap').forEach(item => {
                    const propertie_name = item.querySelector('.option_title').dataset.title;
                    
                    // Check if it's a dropdown (select) or radio button
                    const selectInput = item.querySelector('select');
                    const radioInput = item.querySelector('.radioWrap input:checked');
                    
                    if (selectInput) {
                        // For dropdown (chain length)
                        properties[propertie_name] = selectInput.value;
                    } else if (radioInput) {
                        // For radio buttons
                        properties[propertie_name] = radioInput.dataset.value || '';
                    }
                });          

                let formData = {
                    'items': [{
                        'id': variantID,
                        'quantity': quantity, 
                        properties: properties
                    }]
                };
                
                console.log('🛒 Adding to cart:', formData);
                addProductToCart(btn, formData);
                
            } catch (error) {
                console.error('❌ Add to cart error:', error);
                showError('Failed to add to cart: ' + error.message);
                btn.classList.remove('loading'); 
                btn.disabled = false;
            }
        });
    });
});

// ============================================
// CART FUNCTIONS
// ============================================

function addProductToCart(btn, formData){
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(formData)
    })
    .then(response => {
        if(response.ok){
            setTimeout(() => {
                window.location.href = '/cart';
                btn.classList.remove('loading'); 
                btn.disabled = false;
            }, 2000);
        }
    })
    .catch((error) => {
        console.error('Error:', error);
        btn.classList.remove('loading'); 
        btn.disabled = false;
    });
}

async function fastScreenshot() {
    const target = document.querySelector("#pendantPreview");
    if (!target) return;

    // Helper: Copy computed styles inline
    function cloneWithStyles(sourceElement) {
        const cloned = sourceElement.cloneNode(true);

        const sourceEls = sourceElement.getElementsByTagName("*");
        const clonedEls = cloned.getElementsByTagName("*");

        const copyStyle = (source, target) => {
            const computed = window.getComputedStyle(source);
            for (let prop of computed) {
                target.style[prop] = computed.getPropertyValue(prop);
            }
        };

        // Copy parent styles
        copyStyle(sourceElement, cloned);

        // Copy children styles
        for (let i = 0; i < sourceEls.length; i++) {
            copyStyle(sourceEls[i], clonedEls[i]);
        }

        return cloned;
    }

    // 1. Create hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.top = "-9999px";
    iframe.style.left = "-9999px";
    iframe.style.width = "1200px";
    iframe.style.height = "1200px";
    document.body.appendChild(iframe);

    const doc = iframe.contentDocument;

    // 2. Clone the element with all computed styles
    const styledClone = cloneWithStyles(target);

    // 3. Inject minimal HTML
    doc.open();
    doc.write(`
        <html>
            <head>
                <style>body{margin:0;padding:0;}</style>
            </head>
            <body></body>
        </html>
    `);
    doc.close();

    doc.body.appendChild(styledClone);

    // 4. Wait for images
    await new Promise((res) => setTimeout(res, 200));

    // 5. Screenshot the clean styled clone
    const canvas = await html2canvas(styledClone, {
        scale: 2,
        useCORS: true
    });

    const base64 = canvas.toDataURL("image/png");

    // 6. Cleanup
    document.body.removeChild(iframe);

    return base64;
}

window.addEventListener("pageshow", function (event) {
    if (event.persisted || performance.getEntriesByType("navigation")[0].type === "back_forward") {
        window.location.reload();
    }
});